import {
  GETSUMMERYREPORTLIST_SUCCESS,
  GETSUMMERYREPORTLIST_FAILED,
  RESET_GETSUMMERYREPORTLIST,
  LOADING_GETSUMMERYREPORTLIST,
  NETWORK_ERROR_GETSUMMERYREPORTLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETSUMMERYREPORTLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETSUMMERYREPORTLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETSUMMERYREPORTLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETSUMMERYREPORTLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETSUMMERYREPORTLIST:
      return (state = initialState);
    default:
      return state;
  }
};
